import { Component, OnDestroy, AfterViewChecked, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/index';
import {Models, RequestQueryPayload, Table} from '@cureskin/api-client';
import { ConnectionService } from '@services/connection-service';
import { BroadcastService } from '@services/broadcast-service';
import { EventLoggerService } from '@services/event-logger-service';
import { TimeService } from '@services/time-service';
import { CurrentComponentService } from '@services/current-component';
import SwiperCore, { Scrollbar, Autoplay, Pagination, SwiperOptions } from 'swiper';
import { WindowRefService } from '@services/window-ref-service';
import { Location } from '@angular/common';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CureskinCashSheetComponent } from '@shared/bottom-sheet-layouts/cureskin-cash-sheet/cureskin-cash-sheet.component';
import { CacheService } from '@services/cache-service';
import { AppConfig } from '../../../app.config';
import {CrossSellRegimenService} from '@services/cross-sell-regimen-service/cross-sell-regimen.service';
import { Store } from '@ngrx/store';
import { fromSelectors } from '@store/selectors';
import * as fromActions from '@store/actions/app.actions';
import { RecentlyViewedProductsService } from '@services/recently-viewed-products/recently-viewed-products.service';
import { RecentlyViewedItem, RecentlyViewedEnum } from '@shared/types/recently-viewed.types';
import { CartService } from '@services/cart-service/cart.service';
import { ProductCollection } from '@cureskin/api-client/src/server-api';
import { ExperimentService } from '@services/experiment/experiment.service';
import {PRIMARY_CHANNELS} from '@services/event-logger-service/event-logger.constant';

SwiperCore.use([Autoplay, Scrollbar, Pagination]);
@Component({
  selector: 'user-shop',
  templateUrl: './user-shop.html',
  standalone: false,
})
export class UserShopComponent implements OnDestroy, AfterViewChecked {
  private static readonly SHOP_FIRST_SECTION_PARAM = 'first_revamp_shop_section';
  private firstSectionScrollInterval: any = null;
  private hasScrolledToFirstRevampSection: boolean = false;
  private readonly firstRevampScrollTopGapPx = 64;
  @ViewChild('shopScrollContainer', { static: false }) shopScrollContainer?: ElementRef<HTMLElement>;
  @ViewChild('bogoSection', { static: false }) bogoSection: ElementRef;
  @ViewChild('reorderProductsSection', { static: false }) reorderProductsSection: ElementRef;
  @ViewChild('recommendedProductsSection', { static: false }) recommendedProductsSection: ElementRef;
  @ViewChild('drRecommendedProductsSection', { static: false }) drRecommendedProductsSection: ElementRef;
  @ViewChild('personalisedRecommendationsSection', { static: false }) personalisedRecommendationsSection: ElementRef;
  @ViewChild('superSaverKitsSection', { static: false }) superSaverKitsSection: ElementRef;
  @ViewChild('holiSaleSection', { static: false }) holiSaleSection: ElementRef;
  @ViewChild('forYourBodySection', { static: false }) forYourBodySection: ElementRef;
  @ViewChild('forYourScalpSection', { static: false }) forYourScalpSection: ElementRef;
  @ViewChild('forYourLipsSection', { static: false }) forYourLipsSection: ElementRef;
  searchValue: string = '';
  user: any;
  userLanguageKnOrTa: boolean;
  cart: any;
  isCartPending: boolean;
  cartItems: any = [];
  productsInCart: any = {};
  productsInCartArray: any = [];
  cartDiscount: number = 0;

  totalCashBalance: any;
  totalMRP: number = 0;
  totalSP: number = 0;
  numberOfProductsInCart: number;
  regimens: any = [];
  products: any = [];
  allShopProducts: any = [];
  appLanguageCode: string;

  experiments: Array<any> = [];
  minimumCash: any;
  cashDiscount: any;

  showCashBalance: boolean = false;
  loading: boolean = true;
  isDiscontinued: boolean = false;
  subscriptions: Array<Subscription> = [];
  isBOGOSaleLive: boolean = false;
  isHoliSaleLive: boolean = false;
  saleVariants: any;
  holiSaleVariants: any;
  userDrImage: string;

  newProduct: any;
  oldProduct: any;
  showConfettiAnimation: boolean = false;

  isCheckoutStickyVisible: boolean = true;
  shouldShowStickyWidget: boolean = false;
  // Boost your regimen banners
  isBoostYourRegimenExperiment: boolean = false;
  showDrRecommendedSection: boolean = false;
  userProductsInCart: any[] = [];
  doctorProductsInCart: any[] = [];

  isProgressiveProductBanner: boolean = false;
  progressiveProduct: any;

  isBoostProductBanner: boolean = false;
  boostProductTagName: string = '';
  isBoostProductLoading: boolean = false;
  boostProductList: any[] = [];

  // Personalized Bogo
  isPersonalizedBogoExperiment: boolean = false;
  personalizedBogoTitle: any;

  // Products sections -
  saleProducts: any = [];
  personalizedBogoProducts: any[];
  isBogoProductsPending: boolean = true;

  reorderProducts: any = [];
  addOnProducts: any = [];
  isAddOnAndReorderPending: boolean = true;

  drRecommendedProducts: Array<any> = [];
  kitsProducts: any = [];
  holiSaleProducts: any = [];

  bodyProducts: any = [];
  scalpProducts: any = [];
  lipProducts: any = [];
  isShopTagSectionPending: boolean = true;
  aovTask: boolean = false;
  prodImage: any;
  barStyle: any = {};
  freeProduct: any;
  aovData: any;
  maxPrice: number;
  percentageDone: number = 0;
  amountRemaining: any;
  isAddingToCart: boolean = false;
  allSectionWiseProducts: Record<string, Array<Models.Catalog>> = {};
  searchResultTexts: Array<any> = [];
  searchResultProducts: Array<any> = [];
  showCenterSearchResults: boolean = false;
  private debounceTimer: any = null;
  repairProducts: any[] = [];
  pendingConsultationSession: any;
  latestActiveRegimens: any;
  showRepairProductAutoComplete: boolean;
  newCartUI: boolean = false;
  crossSellRegimenExperiment: any;
  showNewCrossRegimenBanner: boolean = false;
  recentlyViewedData: RecentlyViewedItem[] = [];
  shouldShowRecentlyViewedSection: boolean = false;
  isRecentlyViewedPending: boolean = false;
  recentlyViewedExperiment: any;
  recentlyViewedLocation = RecentlyViewedEnum.Location;
  cartScriptBannerHeaderExperiment: boolean = false;
  // Inventory statuses at which a product is considered unavailable for direct actions
  public readonly UNAVAILABLE_STATUSES: string[] = [
    this.appConfig.Shared.Inventory.Type.DISCONTINUED,
    this.appConfig.Shared.Inventory.Type.RESTRICTED,
  ];
  isShopRevampExperimentOn: boolean = false;
  shopSectionOrder: string[] = [];
  shopSectionFilderStrip: string[] = [];
  shopCollections: {[key: string]: ProductCollection} = {};
  optimiseShopInitialLoad: boolean = false;
  showRecommendedSection: boolean = true;
  stickyHeader: boolean = true;
  isInfiniteLoopEnabled: boolean = false;
  private readonly swiperConfigs = new Map<number, SwiperOptions>();

  constructor(private router: Router,
    public readonly conn: ConnectionService,
    private readonly broadcast: BroadcastService,
    public readonly eventLogger: EventLoggerService,
    public readonly appConfig: AppConfig,
    private readonly currentComponentService: CurrentComponentService,
    public readonly windowRef: WindowRefService,
    private readonly route: ActivatedRoute,
    private readonly location: Location,
    private readonly bottomSheet: MatBottomSheet,
    public readonly timeService: TimeService,
    private readonly changeDetectionRef: ChangeDetectorRef,
    private readonly crossSellRegimenService: CrossSellRegimenService,
    private readonly cacheService: CacheService,
    private readonly store: Store,
    private readonly cartService: CartService,
    private readonly recentlyViewedProductsService: RecentlyViewedProductsService,
    private readonly experimentService: ExperimentService) {
    this.currentComponentService.set(this);
  }

  getSwiperConfig(index: number, name: string): SwiperOptions {
    if (!this.swiperConfigs.has(index)) {
      const config: SwiperOptions = {
        slidesPerView: 1.17,
        pagination: {
          el: `#swiper-pagination-${index}`,
          clickable: true,
          bulletClass: 'tw-h-1 tw-w-1 tw-m-0 bg-white tw-rounded-full',
          bulletActiveClass: 'tw-bg-black'
        },
        spaceBetween: 8,
        threshold: 5,
        loop: this.isInfiniteLoopEnabled,
        loopedSlides: this.isInfiniteLoopEnabled ? this.shopCollections[name]?.products?.length || null : null,
      };
      this.swiperConfigs.set(index, config);
      return config;
    }
    return this.swiperConfigs.get(index)!;
  }

  async ngOnInit(): Promise<any> {
    this.user = await this.conn.getActingUser();
    await this.fetchUserDrImage();
    this.experiments = await this.conn.findUserActiveExperiments();
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'shop-ui-page' }), [
      this.appConfig.Shared.EventTracker.MIXPANEL,
      this.appConfig.Shared.EventTracker.AMPLITUDE,
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    this.getExperiments();
    await this.processOnInit();
    await this.fetchPendingConsultationSessions();
    const { showBanner }: { showBanner: boolean } = this.crossSellRegimenService.evaluateCrossSellProps(
      this.regimens, this.crossSellRegimenExperiment
    );
    this.showNewCrossRegimenBanner = showBanner;
    // Subscribe to Redux store for cart updates
    this.subscriptions.push(
      this.store.select(fromSelectors.selectCartProducts).subscribe((products: { [key: string]: number }) => {
        this.productsInCart = { ...products };
        this.numberOfProductsInCart = Object.values(products).reduce((total: number, quantity: number) => {
          return total + (Number(quantity) || 0);
        }, 0);
      })
    );

    // Subscribe to cart refresh events from recently-viewed-products component
    this.subscriptions.push(
      this.broadcast.on('REFRESH_SHOP_CART').subscribe(() => {
        this.getCart();
      })
    );
    this.loading = false;
  }

  async processOnInit(): Promise<void> {
    try {
      await this.getCart(true);
    } catch (error) {
      console.log('Error fetching cart data:', error);
    }
    this.isBogoProductsPending = true;
    const bogoPromise = Promise.all([
      this.isBOGOSaleLive ? this.fetchSaleProducts() : null,
      this.isPersonalizedBogoExperiment ? this.fetchPersonalizedBogoProducts() : null,
    ]).then((_: any): any => {
      this.isBogoProductsPending = false;
    }).catch((): void => {
      // Ensure scroll gating doesn't get stuck on errors.
      this.isBogoProductsPending = false;
    });
    void bogoPromise;

    this.minimumCash = this.appConfig.Shared.experimentVariants.SHOP_PAGE_CASH_VISIBILITY.minCash;
    this.totalCashBalance = await this.conn.fetchCashBalance();
    if (this.totalCashBalance >= this.minimumCash) {
      this.showCashBalance = true;
    }
    if (!this.user?.get('boostProductSelectedDate')) {
      this.user.set('boostProductSelectedDate', new Date());
      await this.user.save();
    }
    const boostProductSelectedDate = this.user?.get('boostProductSelectedDate');
    if (boostProductSelectedDate) {
      const differenceInDays = this.timeService.differenceInDays(new Date(), new Date(boostProductSelectedDate));
      if (this.user.get('boostProductTag') && differenceInDays <= 15) {
        this.boostProductTagName = this.user.get('boostProductTag');
      }
    }
    this.appLanguageCode = this.conn.currentWebSiteLanguage;
    await this.loadData();
    (<Window> this.windowRef.nativeWindow).performance.mark('shop-page-end');
    const measure: any = (<Window> this.windowRef.nativeWindow).performance
      .measure('shop_page_loading_time', 'shop-page-start', 'shop-page-end');
    this.eventLogger.trackEvent('shop_page_loading_time', {
      durationInMilliSecs: measure.duration,
    });
  }

  public getExperiments(): void {
    this.experiments.forEach(async (experiment: any): Promise<any> => {
      if (experiment.key === 'perosonlized_bogo') {
        this.isPersonalizedBogoExperiment = true;
        this.personalizedBogoTitle = experiment.variant;
      }
      if (experiment.key === 'buy1_get1_sale') {
        this.saleVariants = experiment.variant;
        this.isBOGOSaleLive = true;
      }
      if (experiment.key === 'holi_sale') {
        this.holiSaleVariants = experiment.variant;
        this.isHoliSaleLive = true;
      }
      if (experiment.key === 'show_dr_recommended_section') {
        this.showDrRecommendedSection = true;
      }
      if (experiment.key === 'boost_your_regimen') {
        this.isBoostYourRegimenExperiment = true;
      }
      if (experiment.key === 'aov_gamification' && this.user?.get('orderState') === this.appConfig.Shared.User.OrderState.DELIVERED) {
        this.aovData = experiment.variant;
        this.maxPrice = this.aovData.totalValue;
        const product = await this.conn.findCatalogWithKey([this.aovData.productID]);
        [this.freeProduct] = JSON.parse(JSON.stringify(product));
        if (this.freeProduct?.rebrandedImageWithoutBackground?.length) {
          this.prodImage = this.freeProduct.rebrandedImageWithoutBackground[0];
        } else if (this.aovData?.productImage) {
          this.prodImage = this.aovData.productImage;
        } else if (this.freeProduct.rebrandedImageWithBackground?.length) {
          this.prodImage = this.freeProduct.rebrandedImageWithBackground[0];
        } else if (this.freeProduct?.productUnboxedImage?.length) {
          this.prodImage = this.freeProduct.productUnboxedImage[0];
        }
        this.aovTask = true;
        this.getCart();
      }
      if (experiment.key === 'new_cart_redesign') {
        this.newCartUI = true;
      }
      if (experiment.key === 'cross_sell_regimen_v2') {
        this.crossSellRegimenExperiment = experiment;
      }
      if (experiment.key === 'recently_viewed_products') {
        this.recentlyViewedExperiment = experiment;
      }
      if (experiment.key === 'shop_revamp') {
        this.isShopRevampExperimentOn = true;
        this.shopSectionOrder = experiment.variant?.sectionOrder || [];
        this.stickyHeader = experiment?.variant?.stickyHeader ?? this.stickyHeader;
        this.shopSectionFilderStrip = experiment.variant?.filterStripOrder || [];
        this.showRecommendedSection = experiment.variant?.showRecommendedSection ?? this.showRecommendedSection;
        this.isInfiniteLoopEnabled = experiment.variant?.infiniteLoop;
      }
      if (experiment.key === 'cart_script_banner_header') {
        this.cartScriptBannerHeaderExperiment = true;
      }
    });
  }

  ngAfterViewInit(): void {
    // Perform any initialization that requires the view to be fully loaded
    const params = this.route.snapshot.queryParams;
    if (params.section) {
      if (params.section === UserShopComponent.SHOP_FIRST_SECTION_PARAM) {
        this.checkLoadingAndScrollToFirstShopRevampSection();
      } else {
        this.checkLoadingAndScroll(params.section);
      }
    }
  }

  checkLoadingAndScroll(sectionId: string): void {
    const interval = setInterval((): void => {
      if (!this.loading) { // Check if loading is complete
        this.scrollToSection(sectionId);
        clearInterval(interval);
      }
    }, 1);
  }

  private getFirstShopRevampSectionId(): string | null {
    if (!this.isShopRevampExperimentOn) return null;
    return this.shopSectionOrder?.find((name: string): boolean => !!name && name !== 'filter-strip') ?? null;
  }

  private checkLoadingAndScrollToFirstShopRevampSection(): void {
    if (this.firstSectionScrollInterval) {
      clearInterval(this.firstSectionScrollInterval);
      this.firstSectionScrollInterval = null;
    }
    if (this.hasScrolledToFirstRevampSection) {
      return;
    }

    this.firstSectionScrollInterval = setInterval((): void => {
      if (this.hasScrolledToFirstRevampSection) return;
      if (this.loading || this.isBogoProductsPending || this.isRecentlyViewedPending) return;

      const firstSectionId = this.getFirstShopRevampSectionId();
      if (!firstSectionId) return;

      // first_revamp_shop_section: wait for Shop to finish rendering (API-driven sections + revamp collections),
      // then scroll the first revamp collection into view with a fixed top gap.
      const element = document.getElementById(firstSectionId);
      if (element) {
        this.scrollElementToTopOfShopContainer(element as HTMLElement);
        this.hasScrolledToFirstRevampSection = true;
        clearInterval(this.firstSectionScrollInterval);
        this.firstSectionScrollInterval = null;
      }
    }, 50);
  }

  private scrollElementToTopOfShopContainer(target: HTMLElement): void {
    const container = this.shopScrollContainer?.nativeElement;
    if (!container) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const alignExact = (behavior: ScrollBehavior): void => {
      const containerRect = container.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const delta = (targetRect.top - containerRect.top) - this.firstRevampScrollTopGapPx;
      const top = container.scrollTop + delta;
      container.scrollTo({ top, behavior });
    };

    // Initial smooth scroll
    alignExact('smooth');
    setTimeout(() => alignExact('auto'), 100);
  }

  scrollToSectionById(name: string): void {
    if (name) {
      this.eventLogger.cleverTapEvent(`filter-strip-${name}`);
      document.getElementById(name).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollToSection(section: string): boolean {
    let element: ElementRef;
    let block: ScrollLogicalPosition;

    switch (section) {
      case 'bogoSection':
        element = this.bogoSection;
        block = 'center';
        break;
      case 'reorderProductsSection':
        element = this.reorderProductsSection;
        block = 'center';
        break;
      case 'recommendedProductsSection':
        element = this.recommendedProductsSection;
        block = 'center';
        break;
      case 'drRecommendedProductsSection':
        element = this.drRecommendedProductsSection;
        block = 'center';
        break;
      case 'personalisedRecommendationsSection':
        element = this.personalisedRecommendationsSection;
        block = 'center';
        break;
      case 'superSaverKitsSection':
        element = this.superSaverKitsSection;
        block = 'start';
        break;
      case 'holiSaleSection':
        element = this.holiSaleSection;
        block = 'start';
        break;
      case 'forYourBodySection':
        element = this.forYourBodySection;
        block = 'start';
        break;
      case 'forYourScalpSection':
        element = this.forYourScalpSection;
        block = 'start';
        break;
      case 'forYourLipsSection':
        element = this.forYourLipsSection;
        block = 'start';
        break;
      default:
        return false;
    }
    // Check if element exists, and scroll to the element
    if (element?.nativeElement) {
      element.nativeElement.scrollIntoView({ behavior: 'smooth', block });
      return true;
    }
    return false;
  }

  async loadData(): Promise<void> {
    this.getUserLanguage();
    if (this.isShopRevampExperimentOn) {
      this.isAddOnAndReorderPending = false;
      this.isAddOnAndReorderPending = false;

      try {
        this.isRecentlyViewedPending = true;
        const recentlyViewedPromise = this.fetchRecentlyViewedProducts()
          .finally((): void => { this.isRecentlyViewedPending = false; });
        // Don't block revamp collections loading on recently-viewed; but
        // `first_revamp_shop_section` scroll waits for it to settle.
        this.fetchAllProducts();
        for (const collectionName of this.shopSectionOrder) {
          if (collectionName === 'filter-strip') continue;
          try {
            const productCollection = await this.conn.fetchProductCollection(collectionName);
            this.shopCollections[collectionName] = productCollection;
          } catch (error) {
            console.log('error ', error)
          }
        }
        // Keep local reference alive (TS) even if not awaited.
        void recentlyViewedPromise;
      } catch (error) {
        console.log('error ', error)
        this.isRecentlyViewedPending = false;
      }
    } else {
      try {
        this.isShopTagSectionPending = true;
        this.isAddOnAndReorderPending = true;
        const oldProductPromise = async () => {
          await this.fetchAllProducts();
          await this.fetchShopProducts();
        };
        await Promise.all([
          oldProductPromise(),
          (async (): Promise<void> => {
            this.isRecentlyViewedPending = true;
            try {
              await this.fetchRecentlyViewedProducts();
            } finally {
              this.isRecentlyViewedPending = false;
            }
          })(),
        ])
        this.isShopTagSectionPending = false;
        this.isAddOnAndReorderPending = false;
      } catch (_) {
        this.isShopTagSectionPending = false;
        this.isAddOnAndReorderPending = false;
        this.isRecentlyViewedPending = false;
      }
    }

    // this.loading = false;
    await Promise.all([
      this.fetchKitsProducts(),
      this.fetchRegimens(),
      this.showDrRecommendedSection ? this.fetchDrAddedProducts() : null,
      this.boostProductTagName ? this.fetchBoostProductByType(this.boostProductTagName) : null,
      this.isHoliSaleLive ? this.fetchHoliSaleProducts() : null,
    ]);
  }
  openBottomSheet(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'shop-cash-banner-click' }));
    this.bottomSheet.open(CureskinCashSheetComponent, {
      data: { data: this.totalCashBalance },
    });
  }

  async fetchUserDrImage(): Promise<void> {
    const defaultImg = 'https://cdn.cureskin.com/app/img/dr-charu-main-concern.png';
    const doctorId = this.user.get('allocatedDoctor')?.id;

    if (!doctorId) {
      this.userDrImage = defaultImg;
      return;
    }

    const doc = await this.conn.findUserByObjectId(doctorId);
    this.userDrImage =
      doc?.get('doctorDisplayImage') ||
      doc?.get('DoctorImageThumbnail') ||
      defaultImg;
  }


  async fetchRepairProducts(): Promise<void> {
    // Map over the latestActiveRegimens array to create an array of promises
    const regimenPromises = this.latestActiveRegimens.map((regimen:any): any => this.conn.findRegimenById(regimen.objectId));
    try {
      // Wait for all promises to resolve
      const regimensWithProducts = await Promise.all(regimenPromises);
      // Extract products from each regimen response and filter for repair products
      this.repairProducts = regimensWithProducts?.flatMap((regimenWithProducts:any): any => regimenWithProducts.get('products').filter(
        (each:any): any => each?.get('isRepair')));
      this.repairProducts = JSON.parse(JSON.stringify(this.repairProducts));
    } catch (error) {
      this.broadcast.broadcast('NOTIFY', { message: error.toString() });
    }
  }

  async fetchRegimens(force?: boolean): Promise<any> {
    if (this.isShopRevampExperimentOn) {
      return;
    }
    this.regimens = (await this.conn.fetchRegimens(null, force)).filter((each: any): boolean => !each.expired);
    this.latestActiveRegimens = this.regimens?.filter((regimen: any): boolean => (regimen.delivered && regimen.active));
    this.fetchRepairProducts();
    const latestFaceRegimen = this.latestActiveRegimens.find((regimen: any): boolean => (regimen.class === 'FACE'));
    if (!latestFaceRegimen) return;
    const differenceInDays = this.timeService.differenceInDays(new Date(), new Date(latestFaceRegimen.deliveredDate));
    if (differenceInDays >= 5 && differenceInDays <= 14) {
      this.isProgressiveProductBanner = true;
      const progressiveTreatment = await this.conn.fetchProgressiveProduct();
      // Check if progressive product is already ordered by the user
      if (progressiveTreatment) {
        const orders = await this.conn.fetchOrders({
          user: this.user,
          type: this.appConfig.Shared.Order.Type.PRODUCT,
          progressiveProductInfo: { $exists: true },
          stage: { $nin: [this.appConfig.Shared.Order.Stage.DELIVERED, this.appConfig.Shared.Order.Stage.CANCELED] },
        });
        if (!orders?.length) this.progressiveProduct = null;
      }

      this.progressiveProduct = progressiveTreatment && progressiveTreatment.get('product');

      // Check if the progressive product is already in the cart
      this.cartItems.forEach((item: any): void => {
        if (item.productId === this.progressiveProduct?.id) {
          this.progressiveProduct = null;
        }
      });
    }
    if (differenceInDays >= 20) this.isBoostProductBanner = true;

    if (this.isBoostProductBanner && this.isBoostYourRegimenExperiment && !this.doctorProductsInCart?.length) {
      this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'boost-your-regimen-banner' }), PRIMARY_CHANNELS);
    }

    if (this.isProgressiveProductBanner
      && this.progressiveProduct
      && this.isBoostYourRegimenExperiment
      && !this.doctorProductsInCart?.length) {
      this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'progressive-treatment-banner' }));
    }
  }

  async filterAvailableProducts(products:any[]):Promise<any> {
    return products.filter((product:any):any => product.get('inventoryStatus') === 'AVAILABLE');
  }

  filterAllShopProducts(): void {
    const shopSection = this.appConfig.Shared.ShopSections.TYPE;
    this.allShopProducts = Object.entries(this.allSectionWiseProducts)
      .filter(
        ([key, _]: [string, Models.Catalog[]])
        : boolean => ![shopSection.ReOrder, shopSection.Recommended, shopSection.Doctor]
          .includes(key),
      )
      .map(
        ([key, value]: [string, Models.Catalog[]]): Record<string, Array<Models.Catalog>> => ({ [key]: value }),
      );
  }

  async fetchShopProducts(): Promise<any> {
    this.filterAllShopProducts();
    let scalpProds: any;
    let bodyProds: any;
    let hairFallProds: any = [];
    let dandruffProds: any = [];
    let lipProds: any;
    if (this.allShopProducts && this.allShopProducts.length) {
      const shopMarketingTags = this.appConfig.Shared.ShopSections.MARKETING_TAGS;
      this.allShopProducts.forEach((element: any): any => {
        if (element[shopMarketingTags.MT_BODY] && element[shopMarketingTags.MT_BODY].length) {
          bodyProds = element[shopMarketingTags.MT_BODY];
          this.bodyProducts = JSON.parse(JSON.stringify(bodyProds));
        }
        if (element[shopMarketingTags.MT_SMOKER] && element[shopMarketingTags.MT_SMOKER].length) {
          lipProds = element[shopMarketingTags.MT_SMOKER];
          this.lipProducts = JSON.parse(JSON.stringify(lipProds));
        }
        if ((element[shopMarketingTags.MT_HAIR_FALL] && element[shopMarketingTags.MT_HAIR_FALL].length)) {
          hairFallProds = element[shopMarketingTags.MT_HAIR_FALL];
        }
        if ((element[shopMarketingTags.MT_DANDRUFF] && element[shopMarketingTags.MT_DANDRUFF].length)) {
          dandruffProds = element[shopMarketingTags.MT_DANDRUFF];
        }
      });
      scalpProds = hairFallProds.concat(dandruffProds);
      if (scalpProds && scalpProds?.length) {
        this.scalpProducts = JSON.parse(JSON.stringify(scalpProds));
      }
    }
  }

  async fetchSaleProducts(): Promise<any> {
    const saleProds = await this.conn.findBogoSaleProds();
    const tempSaleProducts = [];
    saleProds?.forEach((element: any): any => {
      tempSaleProducts.push(element.get('product'));
    });
    const availableSaleProducts = await this.filterAvailableProducts(tempSaleProducts);
    availableSaleProducts?.sort((element1: any, element2: any): number => {
      if (element1.get('ranking') === element2.get('ranking')) {
        return 0;
      }
      return element1.get('ranking') > element2.get('ranking') ? 1 : -1;
    });
    this.saleProducts = JSON.parse(JSON.stringify(availableSaleProducts.slice(0, 5)));
  }

  async fetchKitsProducts(): Promise<any> {
    if (this.isShopRevampExperimentOn) {
      return;
    }
    const kitProds = await this.conn.findKitsProducts();
    const availableKitProds = await this.filterAvailableProducts(kitProds);
    availableKitProds.sort((element1: any, element2: any): number => {
      if (element1.get('ranking') === element2.get('ranking')) {
        return 0;
      }
      return element1.get('ranking') > element2.get('ranking') ? 1 : -1;
    });
    this.kitsProducts = JSON.parse(JSON.stringify(availableKitProds.slice(0, 5)));
  }

  async fetchHoliSaleProducts(): Promise<any> {
    const limit = 5;
    const saleProds = await this.conn.findHoliSaleProds(limit);
    const availableSaleProds = await this.filterAvailableProducts(saleProds);
    this.holiSaleProducts = JSON.parse(JSON.stringify(availableSaleProds));
  }

  async fetchPersonalizedBogoProducts(): Promise<any> {
    const payload = {
      username: this.user.get('username'),
      tag: ['BOGO_PRODUCT'],
      responseArray: true,
      limit: 5,
    };
    const personalizedBogoProducts = await this.conn.findProductsForUser(payload);
    const availablepersonalizedBogoProducts = await this.filterAvailableProducts(personalizedBogoProducts);
    this.personalizedBogoProducts = JSON.parse(JSON.stringify(availablepersonalizedBogoProducts));
  }

  async fetchDrAddedProducts(): Promise<any> {
    if (this.isShopRevampExperimentOn) {
      return;
    }
    const payload = {
      username: this.user.get('username'),
      tag: ['DOCTOR_ADDED'],
      responseArray: true,
      limit: 5,
    };
    const products = await this.conn.findProductsForUser(payload);
    this.drRecommendedProducts = JSON.parse(JSON.stringify(products));
  }

  ngAfterViewChecked(): void {
    const params = this.route.snapshot.queryParams;
    if (params.bogo && this.isBOGOSaleLive) {
      const windowRef = this.windowRef.nativeWindow;
      const doc = windowRef.document;
      const bogoSection = doc.getElementById('bogoSection');
      if (bogoSection) {
        bogoSection.scrollIntoView(true);
      }
    }
  }

  goToCart(): void {
    this.eventLogger.cleverTapEvent('cartClicked', JSON.stringify({ name: 'shop' }));
    this.router.navigate(['cart']);
  }

  handleCompleteOrderBannerVisibility(isIntersecting: boolean): void {
    this.shouldShowStickyWidget = !isIntersecting;
    this.changeDetectionRef.detectChanges();
  }

  /**
   * @param firstCall boolean Evaluate DoctorProudcts/UserProducts only once when shop page is loaded.
   * Otherwize every add to product will lead updation/show/hide of the banners
   */
  async getCart(firstCall?: boolean): Promise<void> {
    this.isCartPending = true;
    this.cart = await this.conn.getCart();
    this.cartItems = this.cart.get('lineItems');
    this.fetchDiscount();
    if (firstCall) {
      this.doctorProductsInCart = [];
      this.userProductsInCart = [];
    }
    if (!this.cartItems.length) {
      if (this.aovTask) {
        this.barStyle.width = '1%';
        this.barStyle.backgroundColor = '#D66736';
        const found = this.cartItems.some((el: any): any => el.productId === this.aovData.productID);
        if (found) {
          const params1 = {
            productId: this.aovData.productID,
            quantity: 1,
          };
          await this.conn.removeProductFromCart(params1);
          this.getCart();
        }
      }
      this.amountRemaining = this.maxPrice - this.totalSP;
      this.numberOfProductsInCart = null;
      this.productsInCart = {};
      this.percentageDone = Math.round((this.totalSP / this.maxPrice) * 100);

      // Immediately dispatch empty cart state to Redux store
      this.store.dispatch(fromActions.CartUpdateProductsBegin({
        products: {}
      }));

      this.isCartPending = false;
      return;
    }

    // this is executed when AOV exp is on to add a free product above certain value in cart
    if (this.aovTask) {
      this.percentageDone = Math.round((this.totalSP / this.maxPrice) * 100);
      const foundTwo = this.cartItems.some((el: any): any => el.productId === this.aovData.productID && el.quantity > 1);
      if (this.totalSP < this.maxPrice || foundTwo) {
        const found = this.cartItems.some((el: any): any => el.productId === this.aovData.productID);
        if (found) {
          const params1 = {
            productId: this.aovData.productID,
            quantity: 1,
          };
          await this.conn.removeProductFromCart(params1);
          this.getCart();
        }
        this.amountRemaining = this.maxPrice - this.totalSP;
        this.barStyle.width = `${this.percentageDone}%`;
        this.barStyle.backgroundColor = '#D66736';
      } else {
        this.barStyle.width = '100%';
        this.barStyle.backgroundColor = '#5EAC73';
        this.amountRemaining = 0;
        const found = this.cartItems.some((el: any): any => el.productId === this.aovData.productID);
        if (!found) {
          const params1 = {
            productId: this.aovData.productID,
            quantity: 1,
          };
          await this.conn.addProductToCart(params1);
          this.getCart();
          this.showConfettiAnimation = true;
          setTimeout((): any => {
            this.showConfettiAnimation = false;
          }, 2000);
        }
      }
    }
    this.numberOfProductsInCart = 0;
    this.productsInCart = {};

    // Build cart product quantities for instant synchronization
    const cartProductQuantities: { [key: string]: number } = {};

    this.cartItems.forEach((element: any): void => {
      this.numberOfProductsInCart += Number(element.quantity) || 0;
      // Divide user and doctor products in cart
      if (element?.isDoctorAdded && firstCall) {
        this.doctorProductsInCart.push(element);
      }
      if (firstCall) {
        this.productsInCartArray.push(element);
      }

      // Build quantities for both local state and Redux store
      this.productsInCart[element.productId] = element.quantity;
      cartProductQuantities[element.productId] = element.quantity;
    });

    // Immediately dispatch to Redux store for instant synchronization across all sections
    this.store.dispatch(fromActions.CartUpdateProductsBegin({
      products: cartProductQuantities
    }));

    if (this.doctorProductsInCart?.length) {
      const drAddedProducts = this.doctorProductsInCart.map((each: any): any => each.productId);
      this.drRecommendedProducts = await this.conn.findProductsById(drAddedProducts);
      this.drRecommendedProducts = JSON.parse(JSON.stringify(this.drRecommendedProducts));
    }

    if (firstCall) {
      this.fetchDiscount();
    }
    this.isCartPending = false;
  }

  fetchDiscount(): any {
    this.totalMRP = 0;
    this.totalSP = 0;
    this.cartItems.forEach((element: any): any => {
      this.totalSP += element.quantity * element.price;
      this.totalMRP += element.quantity * element.mrp;
    });
    this.totalMRP = Math.round(this.totalMRP);
    this.totalSP = Math.round(this.totalSP);
    if (this.showCashBalance && !(this.experimentService.applyCashExperiment && this.user?.get('orderState') === this.appConfig.Shared.User.OrderState.DELIVERED)) {
      // When applyCashExperiment is on and user's orderState is DELIVERED, Buy Now CTA should show amount without deducting Cureskin Cash
      this.cashDiscount = Math.min(this.totalCashBalance, this.totalSP);
      this.totalSP -= this.cashDiscount;
    }
    let discount = 0;
    this.totalMRP = Math.floor(this.totalMRP);
    if (this.totalMRP > this.totalSP) {
      discount = Math.floor(((this.totalMRP - this.totalSP) * 100) / this.totalMRP);
    }
    this.cartDiscount = discount;
    this.changeDetectionRef.detectChanges();
  }

  async fetchAllProducts(): Promise<any> {
    this.allSectionWiseProducts = await this.conn.findAllSectionWiseProductsServerAPI();
    const shopSection = this.appConfig.Shared.ShopSections.TYPE;

    // Filter discontinued products that does not have alternates from each section
    this.filterDiscontinuedProducts();

    // Now safely assign filtered products
    this.addOnProducts = this.allSectionWiseProducts[shopSection.Recommended];
    this.reorderProducts = this.allSectionWiseProducts[shopSection.ReOrder];
  }

  filterDiscontinuedProducts(): void {
    Object.keys(this.allSectionWiseProducts).forEach(section => {
      const products = this.allSectionWiseProducts[section];
      if (Array.isArray(products)) {
        this.allSectionWiseProducts[section] = products.filter(product => {
          const hasUnavailableStatus = this.UNAVAILABLE_STATUSES.includes(product.inventoryStatus);
          const hasAlternate = !!product.alternateProduct;

          return !hasUnavailableStatus || hasAlternate;
        });
      }
    });
  }

  back(): void {
    if (this.showCenterSearchResults) {
      this.showCenterSearchResults = false;
      this.searchValue = '';
      return;
    }
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  closeSearch(): void {
    this.searchValue = '';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription): void => subscription.unsubscribe());
    this.sendExitAnalytics();
    this.subscriptions = [];
    this.currentComponentService.remove(this);

    if (this.firstSectionScrollInterval) {
      clearInterval(this.firstSectionScrollInterval);
      this.firstSectionScrollInterval = null;
    }
  }

  exploreAll(): void {
    this.router.navigate(['/user/order/reorder'], { queryParams: { showAll: true } });
  }

  async addToCart(event: any, sectionName: string): Promise<void> {
    if (this.isAddingToCart) {
      return;
    }
    this.isAddingToCart = true;
    try {
      const product = event?.product;
      const image = event?.image;

      if (!product) {
        return;
      }

      // Check if product is discontinued/restricted and get user confirmation
      const guardResult = await this.cartService.checkProductAllowedForCartAndPrompt(product);
      if (!guardResult?.allowed) {
        // User cancelled popup or product not allowed
        return;
      }

      // Use alternate product if provided by guard
      const targetProduct = guardResult.overrideProduct || product;

      // If this is ReOrder section and user accepted alternate, update server-side mapping
      // Check both the section name string and the config value for compatibility
      const shopSection = this.appConfig.Shared.ShopSections.TYPE;
      const isReorderSection = sectionName === 'reorderProducts' || sectionName === shopSection.ReOrder;
      if (guardResult.overrideProduct && isReorderSection) {
        try {
          // Set old and new product for cache update
          this.oldProduct = product;
          this.newProduct = targetProduct;

          await this.conn.replaceDiscontinuedProduct(
            product.objectId,
            targetProduct.id || targetProduct.objectId
          );
          // Update cache after replacing product
          this.updateCache();
        } catch (error) {
          // If replace fails, continue with add to cart
        }
      }

      await this.cartService.addOrRemoveFromCart(
        targetProduct,
        this.appConfig.Shared.Cart.Action.ADD,
        {
          productsInCart: this.productsInCart || {},
          cartItems: this.cart?.get('lineItems') || [],
          img: image,
          skipGuardCheck: true, // Skip guard check since we already did it above
          section: sectionName, // Pass section name for tracking which section the product was added from
        }
      );

      if (this.searchValue.length > 2) {
        this.eventLogger.cleverTapEvent('Click', JSON.stringify({ name: 'advance-search-add-to-cart', value: product.objectId }), [
          this.appConfig.Shared.EventTracker.CLEVER_TAP,
          this.appConfig.Shared.EventTracker.MOENGAGE,
          this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
        ]);
      } else {
        this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'shop-add-to-cart', productId: product.objectId, section: sectionName }));
      }
      await this.getCart();
    } finally {
      this.isAddingToCart = false;
    }
  }

  animateAddToCart(img?: HTMLImageElement): void {
    const image = new Image();
    image.src = img.src;
    image.style.position = 'absolute';
    image.style.top = `${img.getBoundingClientRect().top}px`;
    image.style.right = `${this.windowRef.nativeWindow.innerWidth - img.getBoundingClientRect().right}px`;
    image.style.height = `${img.offsetHeight}px`;
    image.style.width = 'auto';
    image.style.zIndex = '1000';

    image.classList.add('fly-animation');
    image.onanimationend = ((): void => {
      image.remove();
    });
    this.windowRef.nativeWindow.document.body.appendChild(image);
  }

  async reomveFromCart(product: any): Promise<any> {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'shop-remove-from-cart', productId: product.objectId }));
    const quantity = this.cart.get('lineItems').find((p: any): any => p.productId === product.objectId)?.quantity;
    if (!quantity || quantity <= 0) return;

    const params = {
      productId: product.objectId,
      quantity,
    };
    await this.conn.removeProductFromCart(params);
    this.getCart();
  }

  async fetchSearchData(): Promise<any> {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    if (this.searchValue.length <= 2) {
      this.showCenterSearchResults = false;
    }
    if (this.searchValue.length > 2) {
      this.loading = true;
      this.debounceTimer = setTimeout(async ():Promise<any> => {
        await this.performAdvanceSearch();
      }, 1000);
    } else {
      this.loading = false;
    }
  }

  async performAdvanceSearch():Promise<void> {
    this.eventLogger.cleverTapEvent('search', JSON.stringify({ name: 'advance-search-with-term', value: this.searchValue }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    const responseAutocomplete = await this.conn.serverApi.findAutocomplete(
      this.searchValue,
      this.user.get('sessionToken'),
    );
    this.searchResultTexts = responseAutocomplete.data.catalogs.slice(0, 3);
    this.loading = false;
    const responseSearchProducts = await this.conn.serverApi.findCatalogsByKeyword(
      this.searchValue,
      this.user.get('sessionToken'),
    );
    this.searchResultProducts = responseSearchProducts.data.catalogs;
    this.showCenterSearchResults = true;
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'searched-using-center-search' }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
  }

  async selectAutocomplete(autocompleteWord:{title:string}):Promise<void> {
    this.eventLogger.cleverTapEvent('search', JSON.stringify(
      { name: 'advance-search-autocomplete-select', value: autocompleteWord.title }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    this.searchValue = autocompleteWord.title;
    this.loading = true;
    const responseSearchProducts = await this.conn.serverApi.findCatalogsByKeyword(
      this.searchValue,
      this.user.get('sessionToken'),
    );
    this.searchResultTexts = [];
    this.searchResultProducts = responseSearchProducts.data.catalogs;
    this.showCenterSearchResults = true;
    this.loading = false;
  }

  centerSearchClickedHandler(): void {
    this.showRepairProductAutoComplete = true;
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'center-search-click' }));
  }

  async closePopup(isReplace: boolean = false): Promise<void> {
    this.isDiscontinued = false;
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  updateCache(): void {
    const existingReorderCache = this.cacheService.retrieve('CureSkin/reorderProducts');
    const existingShopCache = this.cacheService.retrieve('CureSkin/shopSection');
    if (existingReorderCache) {
      const cachedReorder = existingReorderCache.data.result;
      for (let i = 0; i < cachedReorder.length; i += 1) {
        const currentReorderCache = cachedReorder[i];
        if (currentReorderCache.objectId === this.oldProduct.objectId) {
          cachedReorder[i] = this.newProduct;
          break;
        }
      }
      const updatedReorderCache = JSON.parse(JSON.stringify(existingReorderCache));
      updatedReorderCache.data.result = cachedReorder;
      this.cacheService.store('CureSkin/reorderProducts', updatedReorderCache);
    }

    if (existingShopCache) {
      const cachedShop = existingShopCache.data.result.ReOrder;
      for (let i = 0; i < cachedShop.length; i += 1) {
        const currentShopCache = cachedShop[i];
        if (currentShopCache.objectId === this.oldProduct.objectId) {
          cachedShop[i] = this.newProduct;
          break;
        }
      }
      const updatedShopCache = JSON.parse(JSON.stringify(existingShopCache));
      updatedShopCache.data.result.ReOrder = cachedShop;
      this.cacheService.store('CureSkin/shopSection', updatedShopCache);
    }
  }

  async changeProduct(): Promise<void> {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'discontinued-product-changed' }));
    this.loading = true;
    const res = await this.conn.replaceDiscontinuedProduct(this.oldProduct.objectId,
      this.newProduct.id || this.newProduct.objectId);
    this.updateCache();
    this.isDiscontinued = false;
    if (res) {
      const params = {
        productId: this.newProduct.id || this.newProduct.objectId,
        quantity: 1,
      };
      const cart = await this.conn.addProductToCart(params);
      if (cart) {
        await this.getCart();
        this.closePopup(true);
        await this.loadData();
      }
    }
    this.loading = false;
  }

  async openArticle(): Promise<any> {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'discontinued-product-changed' }));
    await this.conn.replaceDiscontinuedProduct(this.oldProduct.objectId || this.oldProduct.id,
      this.newProduct.id || this.newProduct.objectId);
    this.updateCache();
    this.isDiscontinued = false;
    this.location.replaceState('/user', 'tab=shop');
    this.gotoProduct(JSON.parse(JSON.stringify(this.newProduct)), '');
  }

  async showPopup(data?: any): Promise<void> {
    if (!data) return;
    this.isDiscontinued = true;
    this.oldProduct = data.oldProduct;
    this.newProduct = data.newProduct;
  }

  viewProduct(product: any): void {
    if (product.get('article')?.id) {
      const productData = JSON.parse(JSON.stringify(product));
      this.conn.navigateToURL(`/article/${product.get('article').id}?product=${productData.objectId}`);
    } else {
      const productData = JSON.parse(JSON.stringify(product));
      this.conn.navigateToURL(`/product/${productData.objectId}`);
    }
  }

  async fetchBoostProductByType(type: string, isUserSelect: boolean = false): Promise<void> {
    this.boostProductTagName = type;
    this.isBoostProductLoading = true;
    this.boostProductList = JSON.parse(JSON.stringify(await this.conn.findProducts({ boostYourRegimenTags: type })));
    this.user.set('boostProductTag', type);
    if (isUserSelect) this.user.set('boostProductSelectedDate', new Date());
    await this.user.save();
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `boost-your-regimen-for-${type}` }));
    this.isBoostProductLoading = false;
  }

  async proceedToBuy(event: any, productId: string): Promise<void> {
    event?.stopPropagation();

    const params = {
      productId,
      quantity: 1,
    };
    await this.conn.addProductToCart(params);
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'add-to-cart-progressive-product' }), [
      this.appConfig.Shared.EventTracker.MIXPANEL,
      this.appConfig.Shared.EventTracker.AMPLITUDE,
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    this.router.navigate(['cart']);
  }

  async gotoProduct(product: any, sectionName:any): Promise<void> {
    // Guard against discontinued/restricted products; shows popup if needed
    const guardResult = await this.cartService.checkProductAllowedForCartAndPrompt(product);
    if (!guardResult?.allowed) {
      // User cancelled popup or product not allowed
      // If user clicked "Read More" in popup, handleDiscontinuedReadMore will navigate
      // If user cancelled, do nothing
      return;
    }

    // If alternate product was provided and user confirmed, add to cart instead of navigating
    // This handles the case when user clicks "Add to Cart" in the discontinued popup
    if (guardResult.overrideProduct) {
      const targetProduct = guardResult.overrideProduct;

      // If this is a reorder product, update server-side mapping
      const shopSection = this.appConfig.Shared.ShopSections.TYPE;
      const isReorderSection = sectionName === 'reorderProducts' || sectionName === shopSection.ReOrder;
      if (isReorderSection) {
        try {
          this.oldProduct = product;
          this.newProduct = targetProduct;

          await this.conn.replaceDiscontinuedProduct(
            product.objectId,
            targetProduct.id || targetProduct.objectId
          );
          this.updateCache();
        } catch (error) {
          // If replace fails, continue with add to cart
        }
      }

      // Add alternate product to cart
      await this.cartService.addOrRemoveFromCart(
        targetProduct,
        this.appConfig.Shared.Cart.Action.ADD,
        {
          productsInCart: this.productsInCart || {},
          cartItems: this.cart?.get('lineItems') || [],
          img: undefined,
          skipGuardCheck: true // Already checked above
        }
      );

      // Don't navigate when adding to cart from gotoProduct
      return;
    }

    // No alternate product or user just wants to view - navigate to product detail page
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'product-image', value: product.objectId, section: sectionName }));
    await this.router.navigate([`/product/${product.objectId}`], { queryParams: { section: sectionName } });
  }

  checkout(): void {
    if (this.numberOfProductsInCart) {
      this.router.navigate(['cart']);
    }
  }
  getUserLanguage(): void {
    this.userLanguageKnOrTa = this.user?.get('languagePreference') === 'ta' || this.user?.get('languagePreference') === 'kn';
  }

  async fetchRecentlyViewedProducts(): Promise<void> {
    try {
      const data = await this.recentlyViewedProductsService.getRecentlyViewedData(
        RecentlyViewedEnum.Location.SHOP,
        false,
        this.recentlyViewedExperiment
      );

      if (data?.shouldShowComponent) {
        this.recentlyViewedData = data.items;
        const eventData = {
          bannerName: 'recently_viewed_banner',
          pageName: 'shopPage'
        };
        this.eventLogger.cleverTapEvent('impression', JSON.stringify(eventData));
        this.shouldShowRecentlyViewedSection = true;
      } else {
        this.recentlyViewedData = [];
        this.shouldShowRecentlyViewedSection = false;
      }
    } catch (error) {
      this.recentlyViewedData = [];
      this.shouldShowRecentlyViewedSection = false;
    }
  }

  getCartDataForRecentlyViewed(): any {
    if (!this.cartItems || this.isCartPending) {
      return null;
    }

    return {
      cartItems: this.cartItems,
      totalSP: this.totalSP,
      totalMRP: this.totalMRP,
      discountPercentage: this.cartDiscount,
      freeProductResult: this.aovTask ? {
        shouldShowConfetti: this.showConfettiAnimation,
        amountRemaining: this.amountRemaining,
        percentageDone: this.percentageDone
      } : null
    };
  }

  getProductCartData(productId: string): { quantity: number } | null {
    if (!this.productsInCart) {
      return null;
    }
    const quantity = this.productsInCart[productId] || 0;
    return quantity > 0 ? { quantity } : null;
  }

  viewCollection(collectionName: string): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `view-all-${collectionName}` }),
    );
    this.conn.navigateToURL(`/user/order/reorder?from=${collectionName}&type=collection`);
  }

  sendExitAnalytics(): void {
    this.eventLogger.cleverTapEvent('exit', JSON.stringify({ name: 'shop_page_exit', shopRevamp: this.isShopRevampExperimentOn }));
  }

  async fetchPendingConsultationSessions(): Promise<void> {
    if (this.isShopRevampExperimentOn) {
      this.pendingConsultationSession = [];
      return;
    }
    const payload: RequestQueryPayload<Table.ConsultationSession> = {
      where: {
        user: this.user,
        PrivateMainConcern: { $exists: true },
        archive: false,
        regimen: { $exists: false },
      },
      descending: 'updatedAt',
    };
    const consultationSession = await this.conn.fetchConsultationSessions(payload);
    this.pendingConsultationSession = consultationSession
      ?.filter((session: any): boolean => session?.get('PrivateTreeCompleted') === false);
  }

  get shouldShowOldCrossSellRegimenBanner(): boolean {
    return !this.loading && !this.showNewCrossRegimenBanner && !this.isShopRevampExperimentOn
  }

  get shouldShowRecommendedSection(): boolean {
    return !this.isAddOnAndReorderPending && this.addOnProducts?.length && this.showRecommendedSection;
  }

  get shouldShowCartDetailStrip(): boolean {
    return !!(this.cartItems?.length && this.isCheckoutStickyVisible && this.shouldShowStickyWidget && !this.aovTask && this.searchValue?.length <= 2);
  }
}
